import { createContext, useContext } from 'react';

type InfluencerIdContextType = number;

export const InfluencerIdContext = createContext<InfluencerIdContextType>(0);

export const InfluencerIdProvider = InfluencerIdContext.Provider;

export const useInfluencerId = () => {
  const context = useContext(InfluencerIdContext);

  const isValidNumber = typeof context === 'number' && context >= 0;
  if (!isValidNumber) {
    throw new Error(
      "InfluencerIdContext must be used within a InfluencerIdProvider and can't be undefined",
    );
  }

  return context;
};
